var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"bg-light p-3 rounded"},[(!_vm.hideName)?_c('h4',[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),_c(_vm.component,{tag:"component",attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }